var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footerComponent"},[_c('span',{staticClass:"footerComponent__copyright"},[_vm._v(" "+_vm._s(_vm.$t('footer_copyright'))+" ")]),_c('img',{attrs:{"src":_vm.getImageLogo(),"width":"auto","height":"20","alt":"logo aerolinea"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }